require('./message.scss');
const controller = require('./messageCtrl').default;
const template = require('./message.html');

const deps = [
  require('ui/common/tooltip').name,
  require('ui/web/messageTooltip').name,
  require('data/model/message').name,
  require('data/collection/ledger').name,
  require('ui/web/confirmDialog').name,
  require('data/service/urlParser').name,
  require('data/service/messageParser').name,
  require('ui/web/messagePayload').name,
  require('ui/web/oldMessagePayload').name,
  require('ui/web/notifications').name,
  require('data/model/clientSettings').name,
  require('ui/web/svgIcon').name,
  'ngSanitize',
];

module.exports = angular.module('bench.ui.web.message', deps).component('blMessage', {
  bindings: {
    messageId: '=',
    showAvatar: '=',
    showDate: '=',
    showTime: '=',
    showMessageSource: '<',
    bookkeeperId: '=?',
    editable: '=',
    isFirst: '=?',
    transactionStateName: '=?',
    events: '=?',
    isNewMessageFormattingEnabled: '<',
  },
  template,
  controller,
  controllerAs: 'vm',
});
